import { styled } from "../gatsby-theme-stitches/config"

export const Container = styled("div", {
  px: "$l",
  "@tablet": {
    px: "$xxl",
  },
  maxWidth: "1440px",
  margin: "0 auto",
})
